import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

/**
 * Prevents reusing the `:project-id` route node when the project id changes,
 * so route- and component-scoped providers are destroyed and recreated.
 * This ensures that if we change the project, tasks list is recreated with the new project filters.
 */
@Injectable()
export class ProjectParamRouteReuseStrategy implements RouteReuseStrategy {
  public shouldDetach(): boolean {
    return false;
  }

  public store(): void {}

  public shouldAttach(): boolean {
    return false;
  }

  public retrieve(): DetachedRouteHandle | null {
    return null;
  }

  public shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future.routeConfig !== curr.routeConfig) {
      return false;
    }
    if (future.routeConfig?.path === ':project-id') {
      return future.paramMap.get('project-id') === curr.paramMap.get('project-id');
    }
    return true;
  }
}
